import { CheckCircle, AlertCircle } from "lucide-react";

export default function ActivityItem({ activity }) {
  return (
    <div className="bg-white border border-gray-200 rounded-xl p-6">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          {activity.status === "success" ? (
            <div className="w-10 h-10 rounded-full bg-green-50 flex items-center justify-center flex-shrink-0">
              <CheckCircle className="w-5 h-5 text-green-600" />
            </div>
          ) : (
            <div className="w-10 h-10 rounded-full bg-yellow-50 flex items-center justify-center flex-shrink-0">
              <AlertCircle className="w-5 h-5 text-yellow-600" />
            </div>
          )}
          <div>
            <h3 className="text-base font-bold text-gray-900 mb-1">
              {activity.apiName}
            </h3>
            <p className="text-sm text-gray-600">
              {activity.message || `${activity.method} ${activity.endpoint}`}
            </p>
          </div>
        </div>
        <div className="text-right flex-shrink-0">
          <p className="text-sm font-medium text-gray-900 mb-1">
            {activity.type}
          </p>
          <p className="text-sm text-gray-600">{activity.timestamp}</p>
        </div>
      </div>
    </div>
  );
}
